import { useState, useCallback } from "react";

// useConfirm — drop-in replacement for window.confirm() that uses a modal.
//
// Usage:
//   const { confirmState, requestConfirm, ConfirmDialog } = useConfirm();
//   ...
//   requestConfirm({
//     title: "Delete this camp?",
//     description: "Cannot be undone.",
//     confirmLabel: "Delete Camp",
//     onConfirm: async () => { await adminApi.delete(...); },
//   });
//   ...
//   return <>... <ConfirmDialog /></>
export function useConfirm() {
  const [state, setState] = useState({
    open: false,
    title: "",
    description: "",
    confirmLabel: "Delete",
    cancelLabel: "Cancel",
    destructive: true,
    onConfirm: async () => {},
  });

  const requestConfirm = useCallback((opts) => {
    setState((s) => ({ ...s, ...opts, open: true }));
  }, []);

  const setOpen = useCallback(
    (open) => setState((s) => ({ ...s, open })),
    []
  );

  return { confirmState: state, requestConfirm, setOpen };
}
